import { createSlice } from "@reduxjs/toolkit";

import { REDUX_STATUS } from "constants/status";
import { UserAccount } from "models/User";
import {
  createFactoringUser,
  getAccount,
  getFactoringProfile,
  getICOnboardingInformation,
  getInvitedGroups,
  getPaymentTerms,
  updateFactoringInfo,
  updateFactoringProfile,
  updateUserEmail,
  updateUserProfile
} from "./actions";
import { IUserState } from "./types";

const initialState: IUserState = {
  status: REDUX_STATUS.INITIAL,
  userDetails: null,
  error: null
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Account
      .addCase(getAccount.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(getAccount.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.userDetails = action.payload;
      })
      .addCase(getAccount.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      .addCase(createFactoringUser.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(createFactoringUser.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.userDetails = {
          ...state.userDetails,
          factoring_id: action.payload.id,
          factoring_approved: action.payload.factoring_approved
        } as UserAccount;
      })
      // update factoring info
      .addCase(updateFactoringInfo.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(updateFactoringInfo.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.userDetails = {
          ...state.userDetails,
          factoring_id: action.payload.id,
          factoring_approved: action.payload.factoring_approved
        } as UserAccount;
      })
      .addCase(updateFactoringInfo.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Update user profile
      .addCase(updateUserProfile.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.userDetails = {
          ...action.payload
        } as UserAccount;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Update user email
      .addCase(updateUserEmail.pending, (state) => {
        state.status = REDUX_STATUS.PENDING;
        state.error = null;
      })
      .addCase(updateUserEmail.fulfilled, (state, action) => {
        state.status = REDUX_STATUS.FULFILLED;
        state.userDetails = action.payload;
      })
      .addCase(updateUserEmail.rejected, (state, action) => {
        state.status = REDUX_STATUS.REJECTED;
        state.error = action.error;
      })
      // Get Onboarding Information
      .addCase(getICOnboardingInformation.fulfilled, (state, action) => {
        state.ICOnboardingInformation = action.payload;
      })
      .addCase(getICOnboardingInformation.rejected, (state) => {
        state.ICOnboardingInformation = null;
      })
      // Get Payment Terms
      .addCase(getPaymentTerms.fulfilled, (state, action) => {
        state.paymentTerms = action.payload;
      })
      .addCase(getPaymentTerms.rejected, (state) => {
        state.paymentTerms = [];
      })
      // Get Factoring Profile
      .addCase(getFactoringProfile.fulfilled, (state, action) => {
        state.factoringProfile = action.payload;
      })
      .addCase(getFactoringProfile.rejected, (state) => {
        state.factoringProfile = undefined;
      })
      // Update Factoring Profile
      .addCase(updateFactoringProfile.fulfilled, (state, action) => {
        state.factoringProfile = action.payload;
      })
      .addCase(updateFactoringProfile.rejected, (state) => {
        state.factoringProfile = undefined;
      })
      // get invited groups
      .addCase(getInvitedGroups.fulfilled, (state, action) => {
        state.invitedGroups = action.payload;
      })
      .addCase(getInvitedGroups.rejected, (state) => {
        state.invitedGroups = undefined;
      });
  }
});

export default userSlice.reducer;
